import diffKeys             from '@widesk-core/tools/diffKeys';
import promiseAllSequential from '@widesk-core/tools/promiseAllSequential';
import ApiModel             from '@widesk-core/models/ApiModel';

export default async function savePositionModelRelations<M extends typeof ApiModel>(params: {
	initialModels: InstanceType<M>[];
	modelProp: Extract<keyof InstanceType<M>, string>;
	newUrns: Urn[];
	modelClass: M;
	addedAttributes: (urn: Urn, position: number) => { [key: string]: any };
	removedId: (urn: Urn) => id | undefined;
	sequential?: boolean;
}) {
	const initialUrns = params.initialModels.map(m => m.getUrn(params.modelProp)) as Urn[];
	const { added, removed } = diffKeys(initialUrns, params.newUrns);

	const tasks = [
		...removed.map(urn => () =>
			new params.modelClass({ id: params.removedId(urn as Urn) }).destroy().catch(err => {
				if (err?.connectorError?.status !== 404) {
					throw err;
				}
			}),
		),
		...params.newUrns.map((urn, index) => () => {
			if (added.includes(urn)) {
				return new params.modelClass(params.addedAttributes(urn as Urn, index)).save();
			}
			const initialModel = params.initialModels.find(m => m.getUrn(params.modelProp) === urn) as InstanceType<M>;
			return initialModel.patch({ position: index });
		}),
	];

	if (params.sequential) {
		await promiseAllSequential(tasks);
	} else {
		await Promise.all(tasks.map(fn => fn()));
	}
}
